import { TextField } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';

export interface SubParameterDataType {
  name: string;
  value: string;
}
export interface AddSubParameterProps {
  subParameterData: SubParameterDataType;
  setSubParameterData: React.Dispatch<
    React.SetStateAction<SubParameterDataType>
  >;
}

const AddSubParameter: React.FC<AddSubParameterProps> = ({
  subParameterData,
  setSubParameterData,
}) => {
  const handleSubParameterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSubParameterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <ReportCreateNewLabelField
        label={'Name'}
        width="100%"
        component={
          <TextField
            value={subParameterData.name}
            fullWidth={true}
            name="name"
            height="36px"
            placeholder={'Enter Sub Parameter'}
            inputPropsStyle={{ paddingLeft: '16px' }}
            onChange={handleSubParameterChange}
          />
        }
      />
      <ReportCreateNewLabelField
        width="100%"
        label={'Description'}
        component={
          <TextField
            value={subParameterData.value}
            name="value"
            fullWidth={true}
            height="36px"
            placeholder={'Enter Sub Parameter Description'}
            inputPropsStyle={{ paddingLeft: '16px' }}
            onChange={handleSubParameterChange}
          />
        }
      />
    </>
  );
};

export default AddSubParameter;
